export { default } from './SecondaryInfo';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfListItem/SecondaryInfo/index.js